<template>
    <div class="header-practice">
        <h2 class="header-practice__h">{{ headerText }}</h2>
        <button class="btn-close-practice" @click="this.$store.state.envDev ? closePractice() : closePracticeApi()">
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.567 11.366l-4.37-4.365 4.37-4.364A1.544 1.544 0 1011.384.452L7.01 4.82 2.636.452A1.544 1.544 0 10.453 2.637L4.823 7l-4.37 4.365a1.544 1.544 0 102.183 2.185L7.01 9.183l4.374 4.368c.301.3.696.45 1.092.45a1.543 1.543 0 001.091-2.635z" fill="#333"/></svg>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            headerText: { type: String, default: 'Lorem ipsum' },
        },

        methods: {
            closePractice(){
                let closeConfirmation = window.confirm("Do you want to terminate this practice session?");
                if(closeConfirmation){
                    this.$router.push('/practice-modes');
                }

            },

            closePracticeApi(){

                this.$foneturkConfirmation('Pratik oturumundan çıkmak istiyor musun?', "ÇIKIŞ ONAYI")
                .then(result => {

                    if(result.isConfirmed === false){
                        return;
                    }

                    // Check if the practice is a challenge practice.
                    if(this.$store.state.practiceSession.challengePractice === true){

                        // Emit leavePractice event to trigger disallowing of new requests while leaving request is being processed.
                        this.$emit('leavePractice');
                        
                        // Send request to the API.
                        fetch(this.$store.state.api.challengeLeave, {
                            method: 'POST',
                            credentials: 'include',
                        })
                        .then(async response => {
                            if(response.status !== 200){
                                throw await response.json();
                            }
                            return response.json();
                        })
                        .then(leavingData => {
                            if(leavingData.result !== true){
                                throw new Error('COMPONENT_HEADER_PRACTICE/METHODS/CLOSE_PRACTICE_API::INV_LEAVING_RESULT');
                            }
                            this.$router.push('/practice-modes');
                        })
                        .catch(err => {
                            if(err instanceof Error){
                                console.error(`HEADER_PRACTICE/CLOSE_PRACTICE_API/CHALLENGE_LEAVE_REQUEST::FETCH_ERROR`);
                                this.$foneturkError({
                                    text: this.$t(`error.fetch`),
                                });
                            }
                            else{
                                console.error(`HEADER_PRACTICE/CLOSE_PRACTICE_API/CHALLENGE_LEAVE_REQUEST::UNEXPECTED_API_ERROR`);
                                this.$foneturkError({
                                    text: 'Oturumun beklenmedik bir şekilde sonlandı, tekrar giriş yap.',
                                    didClose: () => {
                                        console.warn('Routing to /login...');
                                        // this.$router.push('/login');
                                    }
                                });
                            }
                        });
                    }
                    else{

                        // Emit leavePractice event to trigger disallowing of new requests while leaving request is being processed.
                        this.$emit('leavePractice');

                        // Send request to the API.
                        fetch(this.$store.state.api.practiceLeave, {
                            method: 'POST',
                            credentials: 'include',
                        })
                        .then(async response => {
                            if(response.status !== 200){
                                throw await response.json();
                            }
                            return response.json();
                        })
                        .then(leavingData => {
                            if(leavingData.result !== true){
                                throw new Error('COMPONENT_HEADER_PRACTICE/METHODS/CLOSE_PRACTICE_API::PRACTICE_LEAVE_INV_LEAVING_RESULT');
                            }
                            this.$router.push('/practice-modes');
                        })
                        .catch(err => {
                            if(err instanceof Error){
                                console.error(`HEADER_PRACTICE/CLOSE_PRACTICE_API/PRACTICE_LEAVE_REQUEST::FETCH_ERROR`);
                                this.$foneturkError({
                                    text: this.$t(`error.fetch`),
                                });
                            }
                            else{
                                console.error(`HEADER_PRACTICE/CLOSE_PRACTICE_API/PRACTICE_LEAVE_REQUEST::UNEXPECTED_API_ERROR --> ${err.code}`);
                                this.$foneturkError({
                                    text: 'Oturumun beklenmedik bir şekilde sonlandı, tekrar giriş yap.',
                                    didClose: () => {
                                        console.warn(`Routing to /login...`);
                                        // this.$router.push('/login');
                                    }
                                });
                            }
                        });
                    }
                });
            },
        }
    };
</script>

<style scoped src="@/css/components/header-practice.css"></style>